export default function(answers) {
    let returnAns = []
    for (let i = 0 ; i < 5 ; i++)
        returnAns.push({
            key: '' + i,
            name: (i + 1),
            user: answers.filter((answer) => answer.value.find((kv) => kv.key == ('' + i)))
        })
    return returnAns
}
